<template>
  <div>
    <div class="q-mt-xl">
      <div class="q-my-lg">
        <div>
          <p></p>
          <q-btn
            color="positive"
            class="btn-cadastro btn"
            no-caps
            label="Criar Novo"
            icon="add"
            @click="rightDrawerOpen = true"
          />
        </div>
      </div>
      <Transition name="slide-fade">
        <q-card v-if="rightDrawerOpen" class="drawer-modal">
          <div class="row q-pa-md text-weight-bold">
            <div class="row col-12 items-center">
              <q-icon
                style="cursor: pointer"
                name="close"
                class="q-mr-md"
                size="22px"
                @click="rightDrawerOpen = false"
              />
              <span class="texto-titulo-modal"
                >{{
                  associarUnidade
                    ? `Associar Unidade: ${catalogo.nome}`
                    : "Criar Catálogo"
                }}
              </span>
            </div>
          </div>
          <div v-if="!associarUnidade" style="width: 100%; height: 89%">
            <div class="column col-12 justify-between no-wrap container-modal">
              <div class="q-px-md text-weight-bold">
                <div>
                  <div class="texto-titulo-input">Nome</div>
                  <q-input v-model="dadoCriarCatalgo.nome" dense outlined />
                </div>
              </div>
              <div class="q-my-sm q-px-md">
                <q-btn
                  label="Criar"
                  color="positive"
                  no-caps
                  icon="done"
                  @click="adicionarCatalogo()"
                />
              </div>
            </div>
          </div>
          <q-scroll-area v-else style="max-width: 100%; height: 85%">
            <div class="row col-12" style="height: 100%">
              <div class="q-px-md col-12 text-weight-bold q-mb-md">
                <div class="row col-12 q-mt-xs items-center q-mb-lg">
                  <div class="col">
                    <div class="texto-titulo-input q-mb-xs">Unidade</div>
                    <SelecaoUnidade
                      @enviarUnidade="receberUnidade"
                      :resetar="resetarUnidade"
                    />
                  </div>
                  <div>
                    <p></p>
                    <q-btn
                      icon="add"
                      flat
                      class="q-mt-xs q-ml-sm"
                      round
                      color="primary"
                      @click="associarUnidadeCatalogo()"
                    />
                  </div>
                </div>
                <div>
                  <div class="texto-titulo-tabela">
                    Lista de Unidades Associadas ao Catalogo
                  </div>
                  <div
                    v-for="(unidade, index) in listaUnidadeAssociada"
                    :key="index"
                    class="row q-mt-xs q-pa-sm items-center justify-between"
                    style="border: 1px solid; border-radius: 5px"
                  >
                    <div
                      style="
                        width: 80%;
                        word-wrap: break-word;
                        word-break: break-all;
                      "
                    >
                      <span class="row col-12 texto-conteudo-tabela">
                        {{ index + 1 }} - {{ unidade.nome }}
                      </span>
                    </div>
                    <!-- <div>
                      <q-btn
                        icon="close"
                        dense
                        flat
                        round
                        color="red"
                        class="q-ml-sm icon-tabela"
                        @click="desassociarUnidadeCatalogo(unidade.unidadeId)"
                      />
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </q-scroll-area>
        </q-card>
      </Transition>
      <div class="q-mt-xl">
        <div class="row col-12 justify-between items-center q-mb-sm">
          <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
            Catálogos Criados
          </div>
          <div class="row col-md-3 col-xs-12 justify-end">
            <q-input
              rounded
              outlined
              dense
              debounce="300"
              type="text"
              class="col-md col-xs-7 input"
              placeholder="Pesquisar"
              v-model="filtros.nome"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>
        </div>
        <q-linear-progress v-if="loading" indeterminate size="3px" />
        <q-table
          :columns="columns"
          :rows="listaCatalogo"
          selection="single"
          v-model:selected="selected"
          dense
          :hide-bottom="!listaCatalogo.length == 0"
          flat
          no-data-label="Nenhum catálogo encontrado."
          :class="{ 'my-sticky-dynamic': !mobile }"
          :grid="mobile"
          :rows-per-page-options="[0]"
        >
          <template v-slot:item="props">
            <div class="q-pa-xs row col-12">
              <q-card class="container-grid-table col-12">
                <div class="q-pa-sm">
                  <div class="row col-12 items-center">
                    <div class="col-6">
                      <div class="row col-12 items-center">
                        <strong class="q-mr-xs">Nome:</strong>
                        <span v-if="!props.selected">
                          {{ props.row.nome }}</span
                        >
                        <input
                          v-else
                          v-model="props.row.nome"
                          class="input-mobile-grid row col-12"
                        />
                      </div>
                    </div>
                    <div class="col">
                      <div class="row col-12 justify-end items-center no-wrap">
                        <div>
                          <q-btn
                            icon="domain"
                            flat
                            round
                            color="secondary"
                            @click="
                              (rightDrawerOpen = true),
                                (associarUnidade = true),
                                (catalogo = {
                                  uuid: props.row.catalogoUuid,
                                  nome: props.row.nome,
                                })
                            "
                          />
                        </div>
                        <div>
                          <q-btn
                            v-if="!props.selected"
                            icon="edit"
                            flat
                            color="primary"
                            :disable="disable"
                            @click="
                              (props.selected = true),
                                (dadoEditarCatalogo = { ...props.row })
                            "
                          />
                          <q-btn
                            v-else
                            icon="done"
                            flat
                            round
                            color="positive"
                            :disable="disable"
                            @click="editarCatalogo(props.row)"
                          />
                        </div>
                        <router-link
                          :to="{
                            name: 'ferramentaria-configuracao-setup',
                            params: {
                              catalogoUuid: props.row.catalogoUuid,
                            },
                          }"
                        >
                          <q-btn round color="black" flat icon="settings" />
                        </router-link>
                        <div>
                          <q-btn
                            icon="delete"
                            flat
                            color="red"
                            :disable="disable"
                            @click="
                              (confirm = true),
                                (catalogo.uuid = props.row.catalogoUuid)
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </q-card>
            </div>
          </template>
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th
                class="text-weight-bolder"
                v-for="col in props.cols"
                :key="col.name"
                :props="props"
              >
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr class="text-brand-5 text-weight-bold">
              <q-td>
                <span v-if="!props.selected">{{ props.row.nome }}</span>
                <q-input
                  v-else
                  class="input-table"
                  v-model="props.row.nome"
                  dense
                  outlined
                />
              </q-td>
              <q-td>
                <span class="row">{{
                  props.row.criadoEm
                    ?.split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}</span>
                <span class="q-ml-sm">{{
                  props.row.criadoEm?.split(" ")[1]
                }}</span>
              </q-td>
              <q-td>
                <q-btn
                  class="q-ml-lg"
                  icon="domain"
                  flat
                  round
                  color="secondary"
                  @click="
                    (rightDrawerOpen = true),
                      (associarUnidade = true),
                      (catalogo = {
                        uuid: props.row.catalogoUuid,
                        nome: props.row.nome,
                      })
                  "
                />
              </q-td>
              <q-td class="coluna-btn">
                <q-btn
                  v-if="!props.selected"
                  icon="edit"
                  color="primary"
                  flat
                  round
                  @click="
                    (props.selected = true),
                      (dadoEditarCatalogo = { ...props.row })
                  "
                />
                <q-btn
                  v-else
                  icon="done"
                  flat
                  round
                  color="positive"
                  :disable="disable"
                  @click="editarCatalogo(props.row)"
                />
              </q-td>
              <q-td class="coluna-btn">
                <router-link
                  :to="{
                    name: 'ferramentaria-configuracao-setup',
                    params: {
                      catalogoUuid: props.row.catalogoUuid,
                    },
                  }"
                >
                  <q-btn color="black" round flat icon="settings" />
                </router-link>
              </q-td>
              <q-td class="coluna-btn">
                <q-btn
                  icon="delete"
                  flat
                  round
                  color="red"
                  :disable="disable"
                  @click="
                    (confirm = true), (catalogo.uuid = props.row.catalogoUuid)
                  "
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <div class="row justify-center q-mt-md">
          <q-pagination
            :disable="disable"
            v-model="pagination.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber"
            :max-pages="5"
            :boundary-numbers="false"
            :direction-links="true"
            :size="mobile ? 'md' : 'sm'"
          />
        </div>
      </div>
      <q-dialog v-model="confirm" persistent>
        <q-card
          class="q-pa-sm container-modal-excluir text-brand-5 text-weight-bolder q-pa-xl"
        >
          <q-card-section class="row col-12 justify-center">
            <span class="texto-excluir-pai"
              >TEM CERTEZA QUE DESEJA EXCLUIR?</span
            >
            <span class="texto-excluir-filho text-brand-5 q-mt-md q-mb-lg">
              Ao clicar em Excluir você estará deletando por definitivo o
              catálogo.</span
            >
          </q-card-section>

          <div class="row col-12 justify-center">
            <q-btn
              no-caps
              label="Excluir"
              color="positive"
              v-close-popup
              class="btn-excluir"
              icon="check_circle_outline"
              @click="excluirCatalogo()"
            />
            <q-btn
              icon="cancel"
              no-caps
              label="Cancelar"
              color="negative"
              class="btn-excluir q-ml-md"
              v-close-popup
            />
          </div>
        </q-card>
      </q-dialog>
    </div>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </div>
</template>

<script>
import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import SelecaoUnidade from "./SelecaoUnidade.vue";

const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "criadoEm",
    label: "Criado Em",
    align: "left",
  },
  {
    name: "unidadeAssociada",
    label: "Unidade Associada",
    align: "left",
  },
  {
    name: "editar",
    label: "Editar",
    align: "left",
  },
  {
    name: "setup",
    label: "Setup",
    align: "left",
  },
  {
    name: "excluir",
    label: "Excluir",
    align: "left",
  },
];
export default {
  components: { SelecaoUnidade },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const rightDrawerOpen = ref(false);
    const dadoCriarCatalgo = ref({ nome: "" });
    const filtros = ref({ nome: "" });
    const listaCatalogo = ref([]);
    const dadoEditarCatalogo = ref({});
    const selected = ref([]);
    const catalogo = ref({ uuid: "", nome: "" });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    const listaUnidadeAssociada = ref([]);
    const resetarUnidade = ref(0);
    const unidadeAssociar = ref({});
    let disable = ref(false);
    let loading = ref(false);
    let confirm = ref(false);
    let mobile = ref(false);
    let associarUnidade = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarCatalogo = async () => {
      await store.state.org.unidadeData.id;
      loading.value = true;
      disable.value = true;
      try {
        const response = await store.dispatch("ferramentaria/listarCatalogo", {
          unidadeId: store.state.org.unidadeData.id,
          nome: filtros.value.nome,
        });
        listaCatalogo.value = response.response.data.resultado.dados;
        pagination.value.page = response.response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.response.data.resultado.total;
        pagination.value.rowsPerPage = response.response.data.resultado.perPage;
        disable.value = false;
        loading.value = false;
      } catch (error) {
        console.log(error);
        loading.value = false;
        disable.value = false;
      }
    };

    const adicionarCatalogo = async (page = 1, rowsNumber = 10) => {
      try {
        const response = await store.dispatch(
          "ferramentaria/adicionarCatalogo",
          {
            unidadeId: store.state.org.unidadeData.id,
            nome: dadoCriarCatalgo.value.nome,
            page: page,
            perPage: rowsNumber,
          }
        );
        rightDrawerOpen.value = false;
        resetVariaveis();
        listarCatalogo();
        if (
          response.response.data.resultado.mensagem ==
          "Catálogo criado, porém já existe associação dessa unidade com outro catálogo."
        ) {
          quasar.notify({
            message:
              "Catálogo criado, porém já existe associação dessa unidade com outro catálogo.",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        quasar.notify({
          message: "Catálogo adicionado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error.response);
      }
    };

    const editarCatalogo = async (row) => {
      if (dadoEditarCatalogo.value.nome === row.nome) {
        selected.value = [];
        return;
      }
      try {
        await store.dispatch("ferramentaria/editarCatalogo", {
          nome: row.nome,
          catalogoUuid: row.catalogoUuid,
        });
        quasar.notify({
          message: "Catálogo editado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        selected.value = [];
        listarCatalogo();
      } catch (error) {
        console.log(error.response);
      }
    };

    const excluirCatalogo = async () => {
      try {
        await store.dispatch("ferramentaria/excluirCatalogo", {
          catalogoUuid: catalogo.value.uuid,
        });
        quasar.notify({
          message: "Catálogo excluído com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarCatalogo();
      } catch (error) {
        if (error.response?.data?.erros.mensagem) {
          quasar.notify({
            message: error.response.data.erros.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const resetVariaveis = () => {
      dadoCriarCatalgo.value.nome = "";
    };

    const listarUnidadeCatalogo = async () => {
      listaUnidadeAssociada.value = [];
      try {
        const response = await store.dispatch(
          "ferramentaria/listarUnidadeCatalogo",
          {
            catalogoUuid: catalogo.value.uuid,
            // nome
          }
        );
        listaUnidadeAssociada.value = response.data.resultado.dados;
      } catch (error) {
        console.log(error);
      }
    };

    const associarUnidadeCatalogo = async () => {
      try {
        await store.dispatch("ferramentaria/associarUnidadeCatalogo", {
          catalogoUuid: catalogo.value.uuid,
          unidadeId: unidadeAssociar.value.id,
        });
        listarUnidadeCatalogo();
        resetarUnidade.value++;
        quasar.notify({
          message: "Unidade associada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao associar unidade.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberUnidade = (value) => {
      unidadeAssociar.value = value;
    };

    const desassociarUnidadeCatalogo = async (unidadeId) => {
      try {
        await store.dispatch("ferramentaria/desassociarUnidadeCatalogo", {
          catalogoUuid: catalogo.value.uuid,
          unidadeId: unidadeId,
        });
        listaUnidadeAssociada();
        quasar.notify({
          message: "Unidade desassociada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao desassociar unidade.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        listarCatalogo();
      }
    );

    watch(
      () => filtros.value.nome,
      () => {
        listarCatalogo();
      }
    );

    watch(
      () => rightDrawerOpen.value,
      () => {
        if (rightDrawerOpen.value == false) {
          associarUnidade.value = false;
        }
        if (associarUnidade.value) {
          listarUnidadeCatalogo();
        }
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarCatalogo(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    onMounted(() => {
      listarCatalogo();
    });

    return {
      columns,
      rightDrawerOpen,
      adicionarCatalogo,
      dadoCriarCatalgo,
      resetVariaveis,
      desassociarUnidadeCatalogo,
      filtros,
      listaCatalogo,
      dadoEditarCatalogo,
      selected,
      editarCatalogo,
      disable,
      loading,
      mobile,
      excluirCatalogo,
      confirm,
      associarUnidadeCatalogo,
      associarUnidade,
      listaUnidadeAssociada,
      catalogo,
      unidadeAssociar,
      resetarUnidade,
      pagination,
      receberUnidade,
      listarUnidadeCatalogo,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
.input {
  width: 180px;
}
tbody tr .coluna-btn {
  width: 120px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
.titulo-tabela {
  font-size: 18px;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100% !important;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.texto-titulo-modal {
  font-size: 16px;
}
.container-modal {
  height: 100%;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.input-table {
  width: 180px;
}
tbody tr .coluna-btn {
  width: 120px;
}
.container-modal-excluir {
  width: 590px;
}
.texto-excluir-pai {
  text-align: center;
  text-justify: inter-word;
  font-size: 23px;
  font-weight: bold;
  color: black;
}
.texto-excluir-filho {
  text-align: center;
  text-justify: inter-word;
  font-size: 15px;
}
.btn-excluir {
  font-size: 16px;
  padding: 0px 25px;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 100%;
    height: 85%;
    overflow: hidden;
    top: 103px;
    width: 340px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
  .btn {
    font-size: 13px;
    margin-bottom: 4px;
  }
  .input-mobile-grid {
    width: 100%;
    outline: none;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .container-modal-excluir {
    width: 100%;
    height: 250px;
    padding: 10px 10px 0px 10px;
    margin: 0px;
    border-radius: 10px;
  }
  .texto-excluir-pai {
    font-size: 17px;
  }
  .texto-excluir-filho {
    font-size: 14px;
  }
  .btn-excluir {
    font-size: 14px;
  }
}
</style>
